
// src/components/checagens/ChecagemImoveisTable.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChecagemImovel } from '../../models/checagens';
import { CAPTACAO_STATUS } from '../../utils/checagens';
import './ChecagemImoveisTable.css'; // I will create this CSS file as well

interface ChecagemImoveisTableProps {
  imoveis: ChecagemImovel[];
}

const ChecagemImoveisTable: React.FC<ChecagemImoveisTableProps> = ({ imoveis }) => {
  const navigate = useNavigate();

  const handleWorkClick = (checagemImovelId: number) => {
    navigate(`/checagens/imovel/${checagemImovelId}/work`);
  };

  return (
    <div className="checagem-imoveis-table-container">
      <h3>Imóveis na Checagem</h3>
      <table className="checagem-imoveis-table">
        <thead>
          <tr>
            <th>ID Imóvel</th>
            <th>Status</th>
            <th>Progresso</th>
            <th>Resultado Captação</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {imoveis.map((ci) => (
            <tr key={ci.id}>
              <td>{ci.imovel_id}</td>
              <td>{ci.status_workflow}</td>
              <td>
                <div className="progress-bar-container">
                  <div
                    className="progress-bar-filler"
                    style={{ width: `${ci.progresso_percent}%` }}
                  ></div>
                </div>
                <span className="progress-text">{ci.progresso_percent}%</span>
              </td>
              <td>{ci.resultado_captacao ? CAPTACAO_STATUS[ci.resultado_captacao] : 'N/A'}</td>
              <td>
                <button className="button-work" onClick={() => handleWorkClick(ci.id)}>Trabalhar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ChecagemImoveisTable;
